<main class="login-page" dir="rtl">
  <!-- ورود به حساب کاربری -->

  <div class="login-shell">
    <div
      class="login-dialog"
      [class.registration]="isSignUpMode"
    >
      <div class="login-card">
        <div class="login-header">
          <div class="login-heading">
            <span class="login-brand">راهداری GPS</span>
            <h1 id="exampleModalLabel">
            {{ bLoginMode ? "ورود به حساب کاربری" : "ثبت نام" }}
            </h1>
          </div>

          <button type="button" class="close-button" aria-label="بستن و بازگشت" (click)="dismissModal()">
            <mat-icon class="mat-18">close</mat-icon>
          </button>
        </div>

        <form [formGroup]="signUpModel" class="login-body">
          <h2 class="step-title" *ngIf="bSendOtp">کد تأیید را وارد کنید</h2>

          <!-- ثبت‌ نام یا OTP -->
          <ng-container *ngIf="!bLoginMode">
            <span class="">
              {{ !bSendOtp ? "" : (otpMessage | faNum) }}

              <button
                *ngIf="bSendOtp"
                type="button"
                id="changeNumber-btn"
                class="change-number"
                (click)="changeNumber()"
              >
                تغییر شماره
              </button>
            </span>
          </ng-container>

          <!-- پیام حالت لاگین -->
          <p class="form-intro" *ngIf="isLoginMode">
            شماره موبایل متعلق به خودتان را وارد کنید.
          </p>

          <!-- فیلد موبایل -->
          <ng-container *ngIf="isLoginMode">
            <label class="field-label" for="login-mobile">شماره موبایل</label>
            <div class="form-group has-icon direction-ltr">
              <span class="form-control-icon">
                <mat-icon class="mat-18">phone_iphone</mat-icon>
              </span>

              <input
                class="w-100 form-control"
                id="login-mobile"
                autocomplete="tel"
                formControlName="strMobile"
                [placeholder]="valid_PlaceHolder | faNum"
                inputmode="numeric"
                appNumericOnly
                [maxlength]="valid_MaxLength"
                type="text"
              />
            </div>
          </ng-container>

          <!-- قوانین در حالت لاگین -->
          <div *ngIf="isLoginMode" class="d-flex mt-2 rules-wrapper">
            <input
              type="checkbox"
              formControlName="rules"
              id="login-rules"
              (change)="checkRules($event)"
              required
            />

            <label class="px-1" for="login-rules">
              <button type="button" class="rules-link" (click)="openAdd()">قوانین و مقررات</button> را
              مطالعه کردم و موافقم
            </label>
          </div>

          <!-- فرم ثبت‌ نام -->

          <ng-container *ngIf="isSignUpMode">
            <!-- نام/نام خانوادگی -->
            <div class="w-100 h-100">
              <div class="row gx-2 gy-0">
                <!-- نام -->

                <div class="col-12 col-md-6">
                  <div class="form-group has-icon">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">person</mat-icon>
                    </span>

                    <input
                      class="w-100 mb-3 mb-md-0 form-control"
                      formControlName="strName"
                  aria-label="نام"
                      placeholder="نام *"
                    />
                  </div>
                </div>

                <!-- نام خانوادگی -->

                <div class="col-12 col-md-6">
                  <div class="form-group has-icon">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">person</mat-icon>
                    </span>

                    <input
                      class="w-100 mb-3 form-control"
                      formControlName="strFamily"
                  aria-label="نام خانوادگی"
                      placeholder="نام خانوادگی *"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row gx-2">
            <!-- کدملی مالک شناور -->
            <div class="col-12 col-md-6"><div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">badge</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                formControlName="strID"
                  aria-label="کد ملی مالک"
                [ngClass]="
                  signUpModel.get('strID').value ? 'direction-ltr' : ''
                "
                placeholder="کد ملی مالک *"
                inputmode="numeric"
                maxlength="10"
                appNumericOnly
              />
            </div></div>

            <!-- تلفن ثابت -->
            <div class="col-12 col-md-6"><div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">fax</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                formControlName="strTel"
                  aria-label="تلفن ثابت"
                [ngClass]="signUpModel.get('strTel').value ? 'direction-ltr' : ''"
                placeholder="تلفن ثابت (اختیاری)"
                inputmode="numeric"
                minlength="8"
                maxlength="11"
                appNumericOnly
              />
            </div></div>
            </div>

            <!-- استان/شهر -->
            <div class="w-100 h-100">
              <div class="row gx-2 gy-0">
                <!-- استان -->

                <div class="col-12 col-md-6">
                  <div class="form-group has-icon">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">apartment</mat-icon>
                    </span>

                    <select
                      class="w-100 mb-3"
                      formControlName="strStateCode"
                  aria-label="استان"
                      (change)="getCity($event.target.value)"
                    >
                      <option value="">استان *</option>

                      <option *ngFor="let s of lst_States" [value]="s.strState">
                        {{ s.strStateName }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- شهر/بندر -->

                <div class="col-12 col-md-6">
                  <div class="form-group has-icon mb-3">
                    <span class="form-control-icon">
                      <mat-icon class="mat-18">apartment</mat-icon>
                    </span>

                    <select class="w-100" formControlName="strCity"
                  aria-label="شهر">
                      <option value="">شهر *</option>

                      <option
                        *ngFor="let c of list_City"
                        [value]="c.strCity.trim()"
                      >
                        {{ c.strCityName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- آدرس محل نصب -->
            <div class="form-group position-relative has-icon mb-3">
              <span class="form-control-icon">
                <mat-icon class="mat-18">add_location_alt</mat-icon>
              </span>

              <input
                class="w-100 form-control"
                formControlName="strAddress"
                  aria-label="آدرس محل نصب"
                [placeholder]="addressPlaceHolder"
              />

              <button type="button" class="map-button" aria-label="انتخاب آدرس روی نقشه" (click)="show_Map()">
                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
              </button>

              <custom-map
                *ngIf="openMap"
                [strValue]="mdl_Map.get('strAddress')?.value"
                [longLat]="[
                  mdl_Map.get('fLon')?.value,
                  mdl_Map.get('fLat')?.value,
                ]"
                [isOpenModal]="true"
                (mdl_Submit)="submitMap($event)"
              >
              </custom-map>
            </div>

            <div class="row gx-2">
            <!-- گروه خودرو -->
            <div class="col-12 col-md-6"><div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">fire_truck</mat-icon>
              </span>
              <select class="w-100 mb-3" formControlName="tiMobileGroup"
                  aria-label="گروه خودرو">
                <option [value]="null" disabled selected>گروه خودرو *</option>
                <option *ngFor="let carType of carTypes$ | async" [value]="carType.tiMobileGroup">
                  {{ carType.strComment }}
                </option>
              </select>
            </div></div>

            <!-- سال تولید -->
            <div class="col-12 col-md-6"><div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">date_range</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                formControlName="iYearConstruction"
                  aria-label="سال تولید"
                [ngClass]="
                  signUpModel.get('iYearConstruction').value
                    ? 'direction-ltr'
                    : ''
                "
                placeholder="سال تولید *"
                inputmode="numeric"
                maxlength="4"
                appNumericOnly
              />
            </div></div>

            <!-- رنگ خودرو -->
            <div class="col-12 col-md-6"><div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">palette</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                formControlName="strColor"
                  aria-label="رنگ خودرو"
                placeholder="رنگ خودرو *"
              />
            </div></div>

            <!-- VIN -->
            <div class="col-12 col-md-6"><div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">barcode_reader</mat-icon>
              </span>

              <input
                class="mb-3 w-100 form-control"
                formControlName="strVIN"
                  aria-label="شماره VIN"
                [ngClass]="signUpModel.get('strVIN').value ? 'direction-ltr' : ''"
                placeholder="VIN *"
                maxlength="17"
              />
              <small class="text-danger" *ngIf="signUpModel.get('strVIN').hasError('minlength') && (signUpModel.get('strVIN').dirty || signUpModel.get('strVIN').touched)">VIN باید ۱۷ کاراکتر باشد.</small>
            </div></div>
            </div>

            <!-- vehicleNumber field -->
            <div class="vehicle-no-field-wrapper">
              <!-- <label for="strVehicleNo">پلاک خودرو</label> -->
              <div class="vehicle-no-field" id="strVehicleNo">
                <input
                  type="text"
                  maxlength="2"
                  inputmode="numeric"
                  class="border-left"
                  formControlName="plak4"
                  aria-label="پلاک، کد ایران"
                  placeholder="- -"
                  (keydown)="onlyNumber($event)"
                />
                <input
                  type="text"
                  maxlength="3"
                  inputmode="numeric"
                  formControlName="plak3"
                  aria-label="پلاک، سه رقم"
                  placeholder="- - -"
                  (keydown)="onlyNumber($event)"
                />
                <input
                  type="text"
                  maxlength="1"
                  formControlName="plak2"
                  aria-label="پلاک، حرف"
                  placeholder="-"
                  (keydown)="onlyPersian($event)"
                  (input)="sanitizePersian($event)"
                />
                <input
                  type="text"
                  maxlength="2"
                  inputmode="numeric"
                  formControlName="plak1"
                  aria-label="پلاک، دو رقم"
                  placeholder="- -"
                  (keydown)="onlyNumber($event)"
                />
                <span><img src="./assets/imgs/iran-flag-dark.svg" /></span>
              </div>
            </div>

            <!-- تصویر کارت خودرو  -->
            <div class="form-group position-relative mb-3">
              <p class="my-2">تصویر کارت خودرو (اختیاری)</p>

              <file-uploader
                [maxFileSize]="3"
                (submit)="onFileSubmit($event)"
              ></file-uploader>
            </div>

            <!-- توضیحات -->
            <div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">description</mat-icon>
              </span>

              <textarea
                style="height: 100px"
                type="text"
                class="w-100 mb-3 form-control"
                placeholder=" توضیحات"
                formControlName="strComment"
                  aria-label="توضیحات"
              ></textarea>
            </div>

            <!-- قوانین ثبت‌ نام -->
            <div class="d-flex rules-wrapper">
              <input
                type="checkbox"
                formControlName="rules"
                id="signup-rules"
                (change)="checkRules($event)"
                required
              />

              <label class="px-1" for="signup-rules">
                <button type="button" class="rules-link" (click)="openAdd()">قوانین و مقررات</button> را
                مطالعه کردم و موافقم
              </label>
            </div>
          </ng-container>

          <!-- فرم OTP -->

          <ng-container *ngIf="isOtpMode">
            <div class="form-group has-icon">
              <span class="form-control-icon">
                <mat-icon class="mat-18">sms</mat-icon>
              </span>

              <input
                class="w-100 my-3 form-control"
                formControlName="strActivateCode"
                  aria-label="کد تأیید"
                [ngClass]="
                  signUpModel.get('strActivateCode').value
                    ? 'direction-ltr'
                    : ''
                "
                placeholder="کد تایید"
                appNumericOnly
                maxlength="4"
                autocomplete="one-time-code"
                inputmode="numeric"
              />
            </div>
          </ng-container>
        </form>

        <div class="login-footer">
          <button
            type="button"
            class="submit-button"
            (click)="onSubmit()"
            [disabled]="isSubmitDisabled"
          >
            {{ !bSendOtp && !bLoginMode ? "ثبت نام" : "تایید" }}
          </button>

          <button
            *ngIf="bSendOtp && !bLoginMode"
            type="button"
            class="resend-button"
            (click)="sendAgain_Otp()"
            [disabled]="otpTimer !== 0"
          >
            ارسال مجدد کد

            <span *ngIf="otpTimer !== 0" class="me-1">
              {{ otpTimer | faNum }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
